module.exports = __webpack_public_path__ + "img/6.eef2825b.png";